import { object, string, array } from 'yup';
import { TFunction } from 'i18next';

export function makeConsultancyInitiationSchema(t: TFunction) {
  return object().shape({
    a: string().required(t('form.required')),
    b: array(string().required(t('form.required'))),
  });
}
